export default __webpack_public_path__ + "static/media/Partner.b183d731.png";